import React, { useEffect, useState } from "react";
import "./style.scss";
import SearchInput from "../SearchInput";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { useSaveSearch } from "hooks/api/useSearch";

function KeywordTab({ setOpen, open }) {
  const [searchKeyword, setSearchKeyword] = useState("");
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const location = useLocation();

  const { mutate: saveMutation } = useSaveSearch({
    onSuccess: (data) => {
      const savedSearchId = data.data.saved_search_id;
      if (savedSearchId) {
        queryClient.invalidateQueries({ queryKey: ["savedSearches"] });
        const params = new URLSearchParams(location.search);
        params.set("k", searchKeyword);
        params.set("st", 1);

        navigate(`/s/${savedSearchId}?${params.toString()}`, { replace: true });
        setOpen(false);
      }
    },
  });

  const saveAndNavigate = (keyword) => {
    if (!keyword) return;
    saveMutation({
      search_type: 1, // keyword - 1, Advanced - 2
      search_mode: 1, // 1 = auto, 2 = manual
      filter_data: {},
      keyword,
    });
  };

  useEffect(() => {
    if (searchKeyword) {
      saveAndNavigate(searchKeyword);
    }
  }, [searchKeyword]);

  return (
    <div className="search-tab-items keyword-tab">
      <SearchInput open={open} onSearch={(value) => setSearchKeyword(value)} />
      <div className="empty-container">
        <span className="empty-image" />
        <div className="flex flex-col gap-3 items-center">
          <h1 className="font-title-normal">Looking for the perfect match?</h1>
          <p className="">
            Our AI-powered search is designed to find profiles that truly align
            with your preferences.
          </p>
        </div>
      </div>
    </div>
  );
}

export default KeywordTab;
